import Vue from 'vue'
import Vuex from 'vuex'
import autoRouter from '../routes'
import {convertTree,convertAuthor} from '../common/js/util'
import cookie from 'vue-cookie'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// count: 10,
        routes: [], // 菜单路由表
        settingRoutes: [] // 设置路由表
	},
	getters: {
        getRoutes: state => state.routes,
        getSettingRoutes: state => state.settingRoutes
	},
	mutations: {
		INCREMENT(state) {
            state.count++
        },
        DECREMENT(state) {
            state.count--
        },
        SET_ROUTES(state, value) {
            
            state.routes = value
        },
        SET_SETTINGROUTES(state, value) {
            state.settingRoutes = value
        }
	},
	actions: {
        getRouterLIst(store, data) {
            return new Promise((resolve, reject) => {
                const index = cookie.get('menuIndex')
                const self = new Vue()
                self.$nextTick(() => {
                    if (index < 2) {
                        let routes = sessionStorage.getItem('menuList')
                        routes = JSON.parse(routes)
                        let mapRoute = []
                        convertTree(routes[index].childMenu, {children: 'childMenu'}, mapRoute) //1获取到的每一个模块的路由,2,判断有没有子节点重新递归
                        let ruter = convertAuthor(autoRouter, mapRoute)  //第一个参数是自己的路由  2接口获取的初始化路由，路由筛选 最终得出一个路由表
                        resolve(ruter)
                    } else {
                        self.$author.getPlatAuthByPlatId({ platId: index }).then(res => {
                            sessionStorage.setItem('platlist', JSON.stringify(res.data.menuList));
                            let mapRoute = []
							convertTree(res.data.menuList, {children: 'childMenu'}, mapRoute)
							let ruter = convertAuthor(autoRouter, mapRoute)
							if (ruter && ruter.length > 0) {
								this.$nextTick(() => {
									this.$store.commit('SET_ROUTES', ruter)
									this.$router.addRoutes(ruter)
									this.$router.push({     //跳转首页
                                        path:ruter[0].redirect,
                                        query: { adminUrl: adminUrl, platID:platID }
                                    })
								})
								ruter.unshift({
									path: '/',
									redirect: ruter[0].path
								})
							} else {
								this.$router.push('/index')
							}
                        })
                    }
                    // store.commit('SET_ROUTES', ruter)
                    // this.$router.addRoutes(ruter)
                    // this.$router.push(ruter[0].redirect)  //跳转首页
                })
            })
        },
        
        getRouterSet(store, data) {
            return new Promise((resolve, reject) => {
                let routes = sessionStorage.getItem('setMenuList')
                const index = cookie.get('setIndex')
                new Vue().$nextTick(() => {
                    routes = JSON.parse(routes)
                    let mapRoute = []
                    convertTree(routes[0].childMenu, {children: 'childMenu'}, mapRoute) //1获取到的每一个模块的路由,2,判断有没有子节点重新递归
                    let ruter = convertAuthor(autoRouter, mapRoute)  //第一个参数是自己的路由  2接口获取的初始化路由，路由筛选 最终得出一个路由表
                    resolve(ruter)
                })
            })
		}
	}
})



// WEBPACK FOOTER //
// ./src/vuex/store.js